import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import BoardPage from '../pages/BoardPage';
import JobDetailPage from '../pages/JobDetailPage';
import CVAnalysisPage from '../pages/CVAnalysisPage';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import JobsPage from '../pages/JobsPage';
import SearchPage from '../pages/SearchPage';
import ReportingPage from '../pages/ReportingPage';
import OnboardingPage from '../pages/OnboardingPage';
import PricingPage from '../pages/PricingPage';
import BillingCallbackPage from '../pages/BillingCallbackPage';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      <Route path="/" element={
          <HomePage />
      } />
      
      {/* Pricing is public so it can be linked from marketing pages */}
      <Route path="/pricing" element={<PricingPage />} />

      <Route path="/billing/callback" element={
        <ProtectedRoute allowUnonboarded>
          <BillingCallbackPage />
        </ProtectedRoute>
      } />

      <Route path="/onboarding" element={
        <ProtectedRoute allowUnonboarded>
          <OnboardingPage />
        </ProtectedRoute>
      } />

      <Route path="/board" element={
        <ProtectedRoute>
          <BoardPage />
        </ProtectedRoute>
      } />
      
      <Route path="/jobs/:id" element={
        <ProtectedRoute>
          <JobDetailPage />
        </ProtectedRoute>
      } />
      
      <Route path="/cv-analysis" element={
        <ProtectedRoute>
          <CVAnalysisPage />
        </ProtectedRoute>
      } />

      <Route path="/jobs" element={
        <ProtectedRoute>
          <JobsPage />
        </ProtectedRoute>
      } />
      <Route path="/search" element={
        <ProtectedRoute>
          <SearchPage />
        </ProtectedRoute>
      } />
      
      <Route path="/reporting" element={
        <ProtectedRoute>
          <ReportingPage />
        </ProtectedRoute>
      } />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes; 